// 全ての .hover-box 要素を取得
const hoverBoxes = document.querySelectorAll(".hover-box");

function createRipple(container) {
  const ripple = document.createElement("div");
  ripple.classList.add("ripple");
  const size = container.offsetWidth;
  ripple.style.setProperty("--ripple-size", size + "px");
  container.appendChild(ripple);

  // アニメーション終了後に要素を削除
  setTimeout(() => {
    ripple.remove();
  }, 2500);
}

// 各 hover-box にイベントリスナーを追加
hoverBoxes.forEach((hoverBox) => {
  let rippleInterval;

  hoverBox.addEventListener("mouseenter", () => {
    // 最初の円を即座に作成
    createRipple(hoverBox);

    // 0.835秒ごとに新しい円を作成
    rippleInterval = setInterval(() => {
      createRipple(hoverBox);
    }, 835);
  });

  hoverBox.addEventListener("mouseleave", () => {
    // ホバーが外れたらインターバルをクリア
    clearInterval(rippleInterval);
  });
});

document.querySelectorAll(".group-item__title").forEach((title) => {
  const list = title.nextElementSibling;
  title.style.cursor = "pointer";
  title.addEventListener("click", () => {
    list.classList.toggle("is-closed");
    title.classList.toggle("is-closed");
  });
});
